import React from 'react'

const PanelIcon = ({ className = '', color = '#151F31' }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M0 4.375C0 3.87772 0.197544 3.40081 0.549175 3.04917C0.900805 2.69754 1.37772 2.5 1.875 2.5H18.125C18.6223 2.5 19.0992 2.69754 19.4508 3.04917C19.8025 3.40081 20 3.87772 20 4.375V15.625C20 16.1223 19.8025 16.5992 19.4508 16.9508C19.0992 17.3025 18.6223 17.5 18.125 17.5H1.875C1.37772 17.5 0.900805 17.3025 0.549175 16.9508C0.197544 16.5992 0 16.1223 0 15.625L0 4.375ZM1.875 3.75C1.70924 3.75 1.55027 3.81585 1.43306 3.93306C1.31585 4.05027 1.25 4.20924 1.25 4.375V15.625C1.25 15.7908 1.31585 15.9497 1.43306 16.0669C1.55027 16.1842 1.70924 16.25 1.875 16.25H18.125C18.2908 16.25 18.4497 16.1842 18.5669 16.0669C18.6842 15.9497 18.75 15.7908 18.75 15.625V4.375C18.75 4.20924 18.6842 4.05027 18.5669 3.93306C18.4497 3.81585 18.2908 3.75 18.125 3.75H1.875Z"
        fill={color}
      />
      <path
        d="M2.5 5.625C2.5 5.45924 2.56585 5.30027 2.68306 5.18306C2.80027 5.06585 2.95924 5 3.125 5H6.875C7.04076 5 7.19973 5.06585 7.31694 5.18306C7.43415 5.30027 7.5 5.45924 7.5 5.625C7.5 5.79076 7.43415 5.94973 7.31694 6.06694C7.19973 6.18415 7.04076 6.25 6.875 6.25H3.75V9.375C3.75 9.54076 3.68415 9.69973 3.56694 9.81694C3.44973 9.93415 3.29076 10 3.125 10C2.95924 10 2.80027 9.93415 2.68306 9.81694C2.56585 9.69973 2.5 9.54076 2.5 9.375V5.625ZM17.5 14.375C17.5 14.5408 17.4342 14.6997 17.3169 14.8169C17.1997 14.9342 17.0408 15 16.875 15H13.125C12.9592 15 12.8003 14.9342 12.6831 14.8169C12.5658 14.6997 12.5 14.5408 12.5 14.375C12.5 14.2092 12.5658 14.0503 12.6831 13.9331C12.8003 13.8158 12.9592 13.75 13.125 13.75H16.25V10.625C16.25 10.4592 16.3158 10.3003 16.4331 10.1831C16.5503 10.0658 16.7092 10 16.875 10C17.0408 10 17.1997 10.0658 17.3169 10.1831C17.4342 10.3003 17.5 10.4592 17.5 10.625V14.375Z"
        fill={color}
      />
    </svg>
  )
}

export default PanelIcon
